export const getDrivers = (auth) => {
  return auth.fetch('/user/drivers', { method: 'GET' });
}

export const createDriver = (auth, driver) => {
  return auth.fetch('/user/driver', { method: 'POST', body: JSON.stringify(driver)});
}

export const getUsers = (auth) => {
  return auth.fetch('/user');
}

export const createUser = (auth, user) => {
  return auth.fetch('/user', { method: 'POST', body: JSON.stringify(user) });
}


// WEBPACK FOOTER //
// ./src/services/UserService.js